import { render, staticRenderFns } from "./PorAutorMunicipal.vue?vue&type=template&id=4b393912&scoped=true"
import script from "./PorAutorMunicipal.vue?vue&type=script&lang=js"
export * from "./PorAutorMunicipal.vue?vue&type=script&lang=js"
import style0 from "./PorAutorMunicipal.vue?vue&type=style&index=0&id=4b393912&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b393912",
  null
  
)

export default component.exports